import { useObservableState } from 'observable-hooks';
import { type Layout } from 'react-grid-layout/legacy';
import facade from 'context/UserContext/facade';
import { type Group, type GroupRule } from 'types/models';
import { type ExtractObservableValueType, type FacadeReturnTypes, getObservableProp, type NullablePartial } from 'utils/modules/state';

interface UserContextFacade extends FacadeReturnTypes<typeof facade> {
   isLoading: boolean;
   error: any;
   context: ExtractObservableValueType<typeof facade.reducedContext$>;
   groups: Group[];
   homeScreenLayout: Layout;
   note: string | null;
   rules: GroupRule[];
   organisationsViewOrder: number[];
}

const defaults: NullablePartial<UserContextFacade> = {
   organisationsViewOrder: [],
   // locale: null,
   // language: null,
   // supportedLanguage: null,
   isLoading: true,
   context: null,
   includeSubsidiaries: false,
   groups: [],
   pageSize: 25,
   organisations: [],
   notifications: [],
   reportingStandards: [],
   reportingPeriods: [],
   rules: [],
   layouts: {},
   homeScreenLayout: [],
   note: null,
};

export default function useUserContext() {
   return {
      state: new Proxy<UserContextFacade>({} as UserContextFacade, {
         get: (target, prop: keyof UserContextFacade) => {
            if (prop === 'error') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.query.selectError());
            }
            if (prop === 'isLoading') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.loading$, defaults[prop]);
            }
            if (prop === 'context') {
               // eslint-disable-next-line react-hooks/rules-of-hooks
               return useObservableState(facade.reducedContext$, defaults[prop]);
            }

            return getObservableProp(facade, defaults, prop);
         },
      }),
      api: facade.api,
   };
}
